<template>
  <div class="warp">
    <div class="warp1">
      <div class="top">
        <div class="top_cent">
          <div class="top_p">
            <p class="top_cent_p">
              <i class="el-icon-location"></i>
              <span>天津</span>
              <i class="el-icon-arrow-down icon"></i>
            </p>
            <p>|</p>
            <p style="margin-top:2px;">
              <img src="../../assets/img/top_btn_home.png" alt />
            </p>
            <router-link :to="{path:'/'}" tag="p" style="padding:0;">
              <a href="#" class="aa">商企服首页</a>
            </router-link>
          </div>
          <ul class="top_ul">
            <li>
              <span style="color:#007BFFFF;">吴丰胜</span>
              <i class="el-icon-arrow-down icon"></i>
            </li>
            <li>商会后台</li>
            <li>卖家中心</li>
            <li>政府机构</li>
            <li>
              <i class="el-icon-phone"></i>022-8821-9596
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--内容 -->
    <div class="content">
      <div class="content_1">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="miaob">
          <el-breadcrumb-item :to="{ path: '/tiwen' }">提问列表</el-breadcrumb-item>
          <el-breadcrumb-item>{{quest.questions_title}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="content1">
      <div class="content1_1" v-if="this.id == '1'">
        <div class="content1_2">
          <div class="content1_2_q">
            <div class="content1_2_q_img">
              <img src="../../assets/img/geren/personal_icon_ask.png" alt />
            </div>
            <div class="content1_2_q_1">
              <p>{{quest.questions_content}}</p>
              <p>{{quest.content}}</p>
              <div class="imgg_tiwen" v-if="quest.image != ''">
                <img v-for="(item,index) in imgg" :key="index" class="imgg_tiwen" :src="item" alt />
              </div>
              <p class="p_bottom">时间：{{quest.created_at}}</p>
            </div>
          </div>
          <div class="content1_2_q">
            <div class="content1_2_q_img">
              <img src="../../assets/img/geren/c.png" alt />
            </div>
            <div class="content1_2_q_1" v-if="quest.status == '0'">
              <p>待处理</p>
              <div class="nohuid">
                <img src="../../assets/img/geren/default_icon_ .png" alt />
                <p>暂未回答您的问题</p>
              </div>
            </div>
            <div class="content1_2_q_1" v-if="quest.status == '1'">
              <p>回答</p>
              <p v-for="(item,index) in quest.Answers" :key="index" class="huida">{{item.Answers}}</p>
              <p class="p_bottom">时间：{{quest.updated_at}}</p>
            </div>
          </div>
          <div class="content1_3">
            <p @click="questionings()">
              <a href="#">评价</a>
            </p>
          </div>
          <div class="content1_3">
            <p @click="question()">
              <a href="#">追问</a>
            </p>
          </div>
        </div>
        <div class="content1_4">
          <div class="content1_4_top" v-show="no_show">
            <el-input type="textarea" :rows="4" placeholder="请输入内容" class="kuestion" v-model="text"></el-input>
            <el-button type="primary" class="submission" @click="submission()">提交</el-button>
          </div>
          <div v-if="quest.is_ask == 2">
            <div class="content1_2_q" style="margin-top:20px;">
              <div class="content1_2_q_img">
                <img src="../../assets/img/geren/personal_icon_ask.png" alt />
              </div>
              <div class="content1_2_q_2" v-for="(item,index) in quest.asks" :key="index">
                <p>{{item.questions_content}}</p>
                <p class="p_bottom">时间：{{item.created_at}}</p>
              </div>
            </div>
            <div class="content1_2_q">
              <div class="content1_2_q_img">
                <img src="../../assets/img/geren/c.png" alt />
              </div>
              <div class="content1_2_q_1" v-if="quest.status === '已回答'">
                <p>{{quest.mechanism.name}}的回答</p>
                <p v-for="(item,index) in quest.Answers" :key="index" class="huida">{{item.Answers}}</p>
                <p class="p_bottom">时间：{{quest.updated_at}}</p>
              </div>
              <div class="content1_2_q_1" v-if="quest.status === '未回答'">
                <p>{{quest.mechanism.name}}的回答</p>
                <div class="nohuid">
                  <img src="../../assets/img/geren/default_icon_ .png" alt />
                  <p>TA暂未回答您的问题</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content1_4">
          <div class="content1_4_top" v-show="show">
            <el-radio-group v-model="radio2" class="kuestsions">
              <el-radio :label="1">非常满意</el-radio>
              <el-radio :label="2" class="kuestsions1">满意</el-radio>
              <el-radio :label="3">不满意</el-radio>
            </el-radio-group>
            <el-input type="textarea" :rows="4" placeholder="请输入内容" class="kuestion" v-model="text"></el-input>
            <el-button type="primary" class="submission" @click="evaluates()">提交</el-button>
          </div>
          <div v-if="quest.is_ask == 2">
            <div class="content1_2_q" style="margin-top:20px;">
              <div class="content1_2_q_img">
                <img src="../../assets/img/geren/personal_icon_ask.png" alt />
              </div>
              <div class="content1_2_q_2" v-for="(item,index) in quest.asks" :key="index">
                <p>{{item.questions_content}}</p>
                <p class="p_bottom">时间：{{item.created_at}}</p>
              </div>
            </div>
            <div class="content1_2_q">
              <div class="content1_2_q_img">
                <img src="../../assets/img/geren/c.png" alt />
              </div>
              <div class="content1_2_q_1" v-if="quest.status === '已回答'">
                <p>{{quest.mechanism.name}}的回答</p>
                <p v-for="(item,index) in quest.Answers" :key="index" class="huida">{{item.Answers}}</p>
                <p class="p_bottom">时间：{{quest.updated_at}}</p>
              </div>
              <div class="content1_2_q_1" v-if="quest.status === '未回答'">
                <p>{{quest.mechanism.name}}的回答</p>
                <div class="nohuid">
                  <img src="../../assets/img/geren/default_icon_ .png" alt />
                  <p>TA暂未回答您的问题</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content1_1" v-if="this.id == '26'">
        <div class="content1_2">
          <div class="content1_2_q">
            <div class="content1_2_q_img">
              <img src="../../assets/img/geren/personal_icon_ask.png" alt />
            </div>
            <div class="content1_2_q_1">
              <p>{{quest.questions_title}}</p>
              <p>{{quest.questions_content}}</p>
              <div class="imgg_tiwen" v-if="quest.image != ''">
                <img v-for="(item,index) in imgg" :key="index" class="imgg_tiwen" :src="item" alt />
              </div>
              <p class="p_bottom">时间：{{quest.created_at}}</p>
            </div>
          </div>
          <div class="content1_2_q">
            <div class="content1_2_q_img">
              <img src="../../assets/img/geren/c.png" alt />
            </div>
            <div class="content1_2_q_1" v-if="quest.status == '已回复'">
              <p>回答</p>
              <p v-for="(item,index) in quest.Answers" :key="index" class="huida">{{item.Answers}}</p>
              <p class="p_bottom">时间：{{quest.updated_at}}</p>
            </div>
            <div class="content1_2_q_1" v-if="quest.status === '待处理'">
              <p>待处理</p>
              <div class="nohuid">
                <img src="../../assets/img/geren/default_icon_ .png" alt />
                <p>暂未回答您的问题</p>
              </div>
            </div>
            <div class="content1_2_q_1" v-if="quest.status === '已受理'">
              <p>已受理</p>
              <div class="nohuid">
                <img src="../../assets/img/geren/default_icon_ .png" alt />
                <p>TA暂未回答您的问题</p>
              </div>
            </div>
            <div class="content1_2_q_1" v-if="quest.status === '已评价'">
              <p>回答</p>
              <p v-for="(item,index) in quest.Answers" :key="index" class="huida">{{item.Answers}}</p>
              <p class="p_bottom">时间：{{quest.updated_at}}</p>
            </div>
          </div>
          <div class="content1_3" v-if="quest.status == '已回复'">
            <p @click="questioning()">
              <a href="#">评价</a>
            </p>
            <!-- <p @click="questioning()">
              <a href="#">追问</a>
            </p>-->
          </div>
        </div>
        <div class="content1_4">
          <div class="content1_4_top" v-show="shows">
            <!-- <el-input type="textarea" :rows="4" placeholder="请输入内容" class="kuestion" v-model="text"></el-input>
            <el-button type="primary" class="submission" @click="submission()">提交</el-button>-->
            <el-radio-group v-model="radio2" class="kuestsions">
              <el-radio :label="1">非常满意</el-radio>
              <el-radio :label="2" class="kuestsions1">满意</el-radio>
              <el-radio :label="3">不满意</el-radio>
            </el-radio-group>
            <el-input type="textarea" :rows="4" placeholder="请输入内容" class="kuestion" v-model="text"></el-input>
            <el-button type="primary" class="submission" @click="evaluate()">提交</el-button>
          </div>
          <div v-if="quest.is_ask == 2">
            <div class="content1_2_q" style="margin-top:20px;">
              <div class="content1_2_q_img">
                <img src="../../assets/img/geren/personal_icon_ask.png" alt />
              </div>
              <div class="content1_2_q_2" v-for="(item,index) in quest.asks" :key="index">
                <p>{{item.questions_content}}</p>
                <p class="p_bottom">时间：{{item.created_at}}</p>
              </div>
            </div>
            <div class="content1_2_q">
              <div class="content1_2_q_img">
                <img src="../../assets/img/geren/c.png" alt />
              </div>
              <div class="content1_2_q_1" v-if="quest.status == '已回复'">
                <p>回答</p>
                <p v-for="(item,index) in quest.Answers" :key="index" class="huida">{{item.Answers}}</p>
                <p class="p_bottom">时间：{{quest.updated_at}}</p>
              </div>
              <div class="content1_2_q_1" v-if="quest.status === '待处理'">
                <p>待处理</p>
                <div class="nohuid">
                  <img src="../../assets/img/geren/default_icon_ .png" alt />
                  <p>暂未回答您的问题</p>
                </div>
              </div>
              <div class="content1_2_q_1" v-if="quest.status === '已受理'">
                <p>已受理</p>
                <div class="nohuid">
                  <img src="../../assets/img/geren/default_icon_ .png" alt />
                  <p>TA暂未回答您的问题</p>
                </div>
              </div>
              <div class="content1_2_q_1" v-if="quest.status === '已评价'">
                <p>回答</p>
                <p v-for="(item,index) in quest.Answers" :key="index" class="huida">{{item.Answers}}</p>
                <p class="p_bottom">时间：{{quest.updated_at}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- di'bu -->
    <div class="floor">
      <div class="floor_1">
        <img src="../../assets/img/bottom_logo_white.png" alt class="img" />
        <ul>
          <li>
            <a href="#">关于商企服</a>
          </li>
          <li>
            <a href="#">商企服服务平台</a>
          </li>
          <li>
            <a href="#">|</a>
          </li>
          <li>
            <a href="#">联系电话：022-8821-9596</a>
          </li>
          <p>Copyright © 1998 - 2019 newcoc. All Rights Reserved.</p>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value1: "",
      numm: 0,
      quest: [],
      imgg: [],
      show: false,
      text: "",
      radio2: "",
      shows: false,
      no_show: false
    };
  },
  methods: {
    // 跳转
    leimu() {
      this.$router.push({ name: "home" });
    },
    questionsList(id) {
      this.id = localStorage.getItem("city_id");
      if (this.id == "1") {
        this.$http(
          "https://ctapi.sqifu.com/api/v1/questionsById",
          {
            id: id
          },
          "post"
        ).then(res => {
          this.quest = res.data.data;
          this.img = res.data.data.image;
          this.imgg = this.img.split(",");
        });
      }
      if (this.id == "26") {
        this.$http(
          "https://ctapi.sqifu.com/api/v1/questionsByIdQy",
          {
            id: id
          },
          "post"
        ).then(res => {
          this.quest = res.data.data;
        });
      }
    },
    questioning() {
      this.shows = true;
    },
    questionings() {
      this.show = true;
    },
    question() {
      this.no_show = true;
    },
    submission(quest, text) {
      this.id = localStorage.getItem("city_id");
      this.imember_idd = localStorage.getItem("member_id");
      this.$http(
        "https://ctapi.sqifu.com/api/v1/createQuestions",
        {
          mechanisms_id: this.quest.mechanism.id,
          city_id: this.id,
          questions_content: this.text,
          content: this.quest.content,
          questions_id: this.imember_idd,
          questions_phone: this.quest.questions.phone,
          questions_username: this.quest.questions.username,
          business_user_id: this.quest.business_user_id,
          pid: this.quest.id
        },
        "post"
      ).then(res => {
        if (res.data.stateCode === 200) {
          this.no_show = false;
          this.quests = res.data.data;
        }
      });
    },
    evaluate() {
      if (this.radio2 == 3) {
        this.$message({
          message: "请说明原因",
          type: "warning"
        });
      } else {
        this.$http(
          "https://ctapi.sqifu.com/api/v1/createQuestionReplayQy",
          {
            questions_id: this.quest.id,
            replay: this.text,
            grade: this.radio2
          },
          "post"
        ).then(res => {
          if (res.data.stateCode === 200) {
            this.$message("评价成功");
            this.show = false;
            this.quests = res.data.data;
          }
        });
      }
    },
    evaluates() {
      if (this.radio2 == 3) {
        this.$message({
          message: "请说明原因",
          type: "warning"
        });
      } else {
        this.$http(
          "https://ctapi.sqifu.com/api/v1/createQuestionReplay",
          {
            questions_id: this.quest.id,
            replay: this.text,
            grade: this.radio2
          },
          "post"
        ).then(res => {
          if (res.data.stateCode === 200) {
            this.$message.success("评价成功");
            this.show = false;
            this.quests = res.data.data;
          }
        });
      }
    }
  },
  created() {
    var id = this.$route.query.questions_id;
    this.id = localStorage.getItem("city_id");
    this.questionsList(id);
    this.$emit("header", true); //是否显示头部
  }
};
</script>

<style scoped>
.dialog {
  width: 28%;
  height: auto;
  margin: 0 auto;
  text-align: center;
}

.dialog p {
  text-align: center;
  margin: 20px 0;
  font-size: 18px;
}
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}
.warp {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
}

.top {
  width: 100%;
  background: #f5f6fa;
}

.top_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.aa {
  color: #222222ff;
}

.top_p {
  font-size: 14px;
  color: #222222ff;
  line-height: 40px;
  float: left;
}

.top_p p {
  float: left;
  padding: 0 12px;
}

.top_cent_p {
  color: #007bffff;
}

.icon {
  color: #000;
}

.top_ul {
  width: 550px;
  height: auto;
  display: flex;
  float: right;
}

.top_ul li {
  font-size: 14px;
  line-height: 40px;
  color: #666666;
  margin-left: 39px;
}
.warp1 {
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
  min-width: 1200px;
}

.top_china {
  width: 100%;
  overflow: hidden;
}

.top_china_cent {
  width: 1200px;
  margin: 0 auto;
}

.top_china_img img {
  padding: 19px 0;
  float: left;
}

.top_china_scout {
  width: 448px;
  height: 44px;
  background: #007bff;
  float: left;
  margin: 19px 0;
  border-radius: 5px;
  margin-right: 11px;
}

.top_china_img p {
  float: left;
  line-height: 82px;
  font-size: 24px;
  font-weight: bold;
  color: #666666ff;
  margin-left: 15px;
}

.input {
  width: 348px;
  height: 38px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  outline: none;
  border: 0;
  margin: 3px 0 0 3px;
  font-size: 16px;
  float: left;
}

.btn {
  width: 97px;
  height: 44px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  outline: none;
  border: 0;
  background: #007bff;
  font-size: 16px;
  color: #fff;
}
.top_china_bot {
  width: 150px;
  height: 44px;
  float: left;
}

.butoon {
  width: 150px;
  height: 44px;
  margin: 19px 0;
  background: #f7681e;
  outline: 0;
  border: 0;
  font-size: 16px;
}

.top_china-sc {
  float: right;
}

.floor {
  width: 100%;
  height: 139px;
  background: #2d3236;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.img {
  padding: 54px 0;
  float: left;
}

.floor_1 ul {
  width: 480px;
  height: 96px;
  float: right;
  padding: 44px 0;
}

.floor_1 ul li a {
  float: left;
  padding: 0 0 0 33px;
  color: #ffffffff;
  font-size: 14px;
}
.floor_1 ul p {
  font-size: 14px;
  font-weight: 400;
  float: right;
  color: #85919aff;
  padding: 20px 0;
}

.content {
  width: 100%;
  height: 48px;
}

.content_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.miaob {
  line-height: 48px;
}

.content1 {
  width: 100%;
  height: auto;
  background: #f4f5f9;
  overflow: hidden;
}

.content1_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
  margin-top: 20px;
}

.content1_2 {
  width: 928px;
  height: auto;
  background: #fff;
  overflow: hidden;
}

.content1_2_q {
  width: 828px;
  height: auto;
  margin: 29px 0 0 14px;
  overflow: hidden;
}

.content1_2_q_1 {
  width: 778px;
  float: right;
  border-bottom: 1px solid #e4e4e4;
  margin-bottom: 30px;
}

.content1_2_q_2 {
  width: 778px;
  float: right;
  border-bottom: 1px solid #e4e4e4;
  margin-bottom: 30px;
}

.content1_2_q_2 p {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
  margin-bottom: 15px;
  margin-top: 8px;
}

.content1_2_q_1 p:nth-child(1) {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  line-height: 20px;
  margin-bottom: 15px;
}
/* 
.content1_2_q_1 p:nth-child(2) {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
  margin-bottom: 15px;
} */

.huida {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
  margin-bottom: 15px;
}

.p_bottom {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  margin-bottom: 31px;
}

.content1_2_q_img {
  width: 22px;
  height: 22px;
  float: left;
}

.content1_3 {
  float: right;
  margin-right: 30px;
}

.content1_3 p {
  float: left;
  width: 100px;
  height: 30px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(0, 123, 255, 1);
  border-radius: 2px;
  text-align: center;
  margin-left: 10px;
  margin-bottom: 30px;
}

.content1_3 p a {
  line-height: 30px;
  font-size: 12px;
  color: #007bff;
}

.content1_3 p:hover {
  background: #007bff;
}

.content1_3 p:hover a {
  color: #fff;
}

.imgg_tiwen {
  width: 100%;
  height: auto;
  float: left;
  margin-bottom: 10px;
}

.imgg_tiwen img {
  width: 140px;
  height: 104px;
  float: left;
  margin-right: 10px;
}

.content1_4 {
  width: 928px;
  height: auto;
  background: #fff;
  margin-top: 20px;
  margin-bottom: 20px;
  overflow: hidden;
}

.content1_4_top {
  width: 100%;
  height: 200px;
}

.kuestion {
  width: 828px;
  height: 104px;
  margin: 30px 48px;
  outline: 0;
}

.kuestsions {
  width: 828px;
  margin: 20px 48px;
}

.kuestsions1 {
  margin: 0 28px;
}

.submission {
  width: 100px;
  height: 30px;
  float: right;
  margin-right: 48px;
}

.nohuid {
  width: 138px;
  height: auto;
  margin: 30px auto;
}

.nohuid img {
  margin: 0 35px;
}

.nohuid p {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/geren/Tiwenliebiao.vue